function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isObject = function isObject(x) {
  return _typeof(x) === 'object' && x != null;
};
/**
 * Applies a patch to an object recursively such
 * that all nested objects can be updated without
 * overriding the nested objects completely. If a value is passed then
 * the patch is returned (only if state is not an object already)
 * @param {Object|any} obj1 - the object to patch
 * @param {Object|any} obj2 - the patch to apply
 * @returns {any} an object (or other value) with the patch applied
 */


export function updateState(obj1, obj2) {
  var guardedObj2 = obj2 || {};
  if (!isObject(obj1) && !isObject(obj2)) return obj2;
  return Object.keys(guardedObj2).reduce(function (previous, key) {
    var previousValue = previous[key];
    var newValue = guardedObj2[key];

    if (newValue && !(newValue instanceof Array) && !(newValue instanceof Error) && _typeof(newValue) === 'object') {
      return _objectSpread(_objectSpread({}, previous), {}, _defineProperty({}, key, updateState(previousValue || {}, newValue)));
    }

    if (typeof newValue === 'function') {
      return _objectSpread(_objectSpread({}, previous), {}, _defineProperty({}, key, newValue(previousValue)));
    }

    return _objectSpread(_objectSpread({}, previous), {}, _defineProperty({}, key, newValue));
  }, obj1 || {});
}
/**
 * Given the feeds state, update a single
 * story with the details provided without
 * overriding unrelated story details
 * @param {string} path - the objects property path (e.g. `stories.<storyId>`)
 * @param {Object} state - the original / target object to update
 * @param {Object} newSubState - the patch to apply at the given path in the object
 * @param {Object} options
 * @param {string} [delimiter = '.'] the path delimiter to use
 *
 * @returns {Object} the new state with patch applied
 */

export function updateAt(path, state, newSubState) {
  var delimiter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  var guardedPath = path || [];
  var pathSegments = typeof guardedPath === 'string' ? guardedPath.split(delimiter) : guardedPath;

  if (pathSegments.length === 0) {
    return updateState(state || {}, newSubState);
  }

  if (pathSegments.length === 1 && !isObject(newSubState)) {
    return updateState(state, _defineProperty({}, pathSegments[0], newSubState));
  }

  var nextSegment = pathSegments.splice(0, 1);
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, nextSegment, updateAt(pathSegments, state[nextSegment] || {}, newSubState)));
}
/**
 * Given the feeds state, apply the updates in sequence feeding the last updated state
 * into the next
 * @param {Object} state - the base input state to start applying updates to
 * @param {Array.<Object>} stateUpdates - the state updates
 * @param {string|Array} stateUpdates.path - the path of the update
 * @param {Object} stateUpdates.update - the update patch
 * @returns {Object} the new state with patches applied
 */

export function cascadeUpdates() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var stateUpdates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return stateUpdates.reduce(function (acc, cur) {
    return updateAt(cur.path, acc, cur.update);
  }, state);
}
/**
 * Creates an operation for modifying a number by a specific count and
 * will honor a floor value of 0 to handle negative additions
 * @param {number} count integer to add to the previous value
 * @param {Object} options
 * @param {number} options.max the limit to incrementing
 * @returns {Function} operation for adding to a number
 */

export var incrementBy = function incrementBy(count) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 99 : _ref$max;

  return function (previous) {
    return Math.min((previous || 0) + count, max);
  };
};
/**
 * Creates an operation for modifying a number by a specific count and
 * will honor a floor value of 0
 * @param {number} count integer to subtract from the previous value
 * @param {Object} options
 * @param {number} options.min the limit to decrementing
 * @returns {Function} operation for subtracting from a number
 */

export var decrementBy = function decrementBy(count) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$min = _ref2.min,
      min = _ref2$min === void 0 ? 0 : _ref2$min;

  return function (previous) {
    return Math.max((previous || 0) - count, min);
  };
};
/**
 * Creates an operation for removing an item from the previous array when the
 * predicate condition is met
 * @param {Function} predicate boolean returning function, when true is returned true
 *                  item will be removed
 * @returns {Function} operation for removing an object from an array
 */

export var removeItemWhen = function removeItemWhen(predicate) {
  return function (previous) {
    return (previous || []).filter(function (x, i, arr) {
      return !predicate(x, i, arr);
    });
  };
};
/**
 * Creates an operation for removing an item from the previous array either a string or
 * @param {Object|string} item the item OR item Id to remove
 * @param {Object} options
 * @param {string} options.[idKey='id'] the id key that identifies the object for equality checking
 * @returns {Function} operation for removing an object from an array
 */

export var removeItem = function removeItem(item) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$idKey = _ref3.idKey,
      idKey = _ref3$idKey === void 0 ? 'id' : _ref3$idKey;

  var predicate = _typeof(item) === 'object' ? function (x) {
    return item[idKey] === x[idKey];
  } : function (x) {
    return item === x;
  };
  return removeItemWhen(predicate);
};
/**
 * Creates an operation for updating an item in the previous array when the
 * predicate condition is met
 * @param {Function} predicate boolean returning function, when true is returned true
 *                  item will be updated with the given patch
 * @returns {Function} operation for updating an object in an array
 */

export var updateItemWhen = function updateItemWhen(predicate) {
  var patch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (previous) {
    return (previous || []).map(function (x, i, arr) {
      return predicate(x, i, arr) ? updateState(x, patch) : x;
    });
  };
};
/**
 * Creates an operation for updating an item at particular index within an array
 * @param {number} index
 * @param {any} item
 * @returns {Function} operation for updating an item in an array
 */

export var replaceItem = function replaceItem(index, item) {
  return function (previous) {
    var copy = (previous || []).concat();
    copy[index] = item;
    return copy;
  };
};
/**
 * Creates an operation for adding an item to the previous array at the front
 * @param {number|string|Object|Array} item generic item to add to the array
 * @returns {Function} operation for prepending to an array
 */

export var prepend = function prepend(item) {
  return function (previous) {
    return (item instanceof Array ? item : [item]).concat(previous || []);
  };
};
/**
 * Creates an operation for adding an item to the previous array at the end
 * @param {number|string|Object|Array} item generic item to add to the array
 * @returns {Function} operation for appending to an array
 */

export var append = function append(item) {
  return function (previous) {
    return (previous || []).concat(item);
  };
};
/**
 * Takes an input array of objects and an array of objects and filters on a key for uniques
 * @param {Array.<string>} [existing = []] the existing list to add to
 * @param {Array.<string>} [incoming = []] the incoming list to append
 * @param {Object} options
 * @param {string} options.[idKey='id'] the id key that identifies the object
 * @return {Array.<string>} The final list of ordered story Ids for the client to maintain
 *  for this user.
 */

export function combineUniquesByKey() {
  var array1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var array2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref4$idKey = _ref4.idKey,
      idKey = _ref4$idKey === void 0 ? 'id' : _ref4$idKey;

  var keyMap = {};

  for (var i = 0; i < array1.length; i += 1) {
    if (array1[i][idKey] !== undefined) {
      keyMap[array1[i][idKey]] = i;
    }
  }

  return array1.concat(array2.filter(function (obj) {
    return keyMap[obj[idKey]] === undefined;
  }));
}
/**
 * Creates an operation for updating the previous array with the given new items without
 * adding duplicates
 * @param {Array.<Object>} items the items to append to the previous array
 * @param {Object} options
 * @param {string} options.[idKey='id'] the id key that identifies the object
 * @returns {Function} operation for appending items to an array without duplicates
 */

export var appendNew = function appendNew(items) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref5$idKey = _ref5.idKey,
      idKey = _ref5$idKey === void 0 ? 'id' : _ref5$idKey;

  return function (previous) {
    return combineUniquesByKey(previous, items, {
      idKey: idKey
    });
  };
};